module.exports = __webpack_public_path__ + "static/media/team-dan.84714844.jpg";